import { render, staticRenderFns } from "./IdInfoPhotos.vue?vue&type=template&id=427fa419&"
import script from "./IdInfoPhotos.vue?vue&type=script&lang=js&"
export * from "./IdInfoPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports